import { Variazione } from '../../Progetti/Models/Variazione';
import { Prodotto } from '../../Progetti/Models/Prodotto';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ApiRestService } from '../../Progetti/_services/api-rest.service';
import { ProdottiStoreService } from '../../Progetti/_services/prodotti-store.service';
import { FiltriProdotto } from '../../Progetti/Models/FiltriProdotto';
import { Categorie } from 'src/app/Prima_Nota/Models/Categorie';
import { PartiStoreService } from '../../Progetti/_services/parti-store.service';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-parti-prodotto',
  templateUrl: './parti-prodotto.component.html'
})
export class PartiProdottoComponent implements OnInit {
  @Input() isModifyDisabled: boolean = false;
  @Input() Parti: Prodotto[] = [];
  @Output() PartiChange = new EventEmitter<Prodotto[]>();
  @Input() Variazioni: Variazione[] = []; //[ {id: 1 ,categoria: "Cerniere" ,parti: [
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined},
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined},
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined},
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined},
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined},
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined},
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined},
  //   {id: 6, nome: "Vitello tonnato grigio",  page: undefined, size: undefined}
  // ]}];
  @Output() VariazioniChange = new EventEmitter<Variazione[]>();
  prodotti: Prodotto[] = [];
  prodottiSelezionati: Prodotto[] = [];
  prodottiVariazioniSelezionati: Prodotto[] = [];
  CategorieLineare: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  qtavar: number = 1;
  qtaParti: number = 1;
  partdropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nome',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  constructor(
    private apiRestService: ApiRestService,
    private prodottiStore: ProdottiStoreService,
    private partiStore: PartiStoreService,
    private toastService: ToastrService,
  ) { }

  ngOnInit() {
    this.partiStore.$prodotti.subscribe(x => this.prodotti = x.data);
    //this.partiStore.getCategorieProdotti();
    this.partiStore.$categorieProdottiLineare.subscribe(data => this.CategorieLineare = data);
  }
  add() {
    console.log(this.prodottiSelezionati)
    if (!this.prodottiSelezionati || this.prodottiSelezionati == null || this.prodottiSelezionati.length < 1)
      this.toastService.warning("inserire la parte da aggiungere", "Heyy!");
    else if (this.Variazioni.findIndex(x=> x.parti.findIndex(x=>x.id == this.prodottiSelezionati[0].id) >-1) > -1)
      this.toastService.warning("Questa parte è stata gia inserita come variazione", "Heyy!");
    else if (this.Parti.findIndex(x=>x.id == this.prodottiSelezionati[0].id) >-1)
      this.toastService.warning("Questa parte è stata gia inserita", "Heyy!");
    else {
        this.prodottiSelezionati[0].qta = this.qtaParti;
        this.Parti.push(this.prodottiSelezionati[0]);
        this.prodottiSelezionati = [];
      this.PartiChange.emit(this.Parti);
    }
  }
  addvar() {
    console.log(this.prodottiVariazioniSelezionati)
    if (!this.prodottiVariazioniSelezionati || this.prodottiVariazioniSelezionati == null || this.prodottiVariazioniSelezionati.length < 1)
      this.toastService.warning("inserire la parte da aggiungere", "Heyy!");
    else if (!this.CategorieSelezionate || this.CategorieSelezionate == null || this.CategorieSelezionate.length < 1)
      this.toastService.warning("inserire la categoria di appartenenza della parte da aggiungere", "Heyy!");
    else if (this.Variazioni.findIndex(x=> x.parti.findIndex(x=>x.id == this.prodottiVariazioniSelezionati[0].id) >-1) > -1)
      this.toastService.warning("Questa parte è stata gia inserita", "Heyy!");
    else if (this.Parti.findIndex(x=>x.id == this.prodottiVariazioniSelezionati[0].id) >-1)
      this.toastService.warning("Questa parte è stata gia inserita come parte fissa", "Heyy!");
    else {
      var cat: number = this.Variazioni.findIndex(x=> x.categoria == this.CategorieSelezionate[0].categoria);
      this.prodottiVariazioniSelezionati[0].qta = this.qtavar;
      if (cat > -1 && this.Variazioni[cat].parti){
        this.Variazioni[cat].parti.push(this.prodottiVariazioniSelezionati[0]);
      } else if (cat > -1) {
        this.Variazioni[cat].parti = [];
        this.Variazioni[cat].parti.push(this.prodottiVariazioniSelezionati[0]);
      } else {
        this.Variazioni.push({id: this.CategorieSelezionate[0].id, categoria: this.CategorieSelezionate[0].categoria, parti: [this.prodottiVariazioniSelezionati[0]] })
      }
      this.prodottiVariazioniSelezionati = [];
      this.VariazioniChange.emit(this.Variazioni);
    }
  }
  delete(item) {
    const idx: number = this.Parti.findIndex(x => x == item);
    if ( idx > -1) {
      this.Parti.splice(idx, 1);
      this.PartiChange.emit(this.Parti);
    }
  }
  deletevar(item: Variazione, parte: Prodotto) {
    var cat: number = this.Variazioni.findIndex(x=> x == item);
    if(cat > -1){
      const indx = this.Variazioni[cat].parti.findIndex(x=> x.id == parte.id);
      if ( indx > -1) {
        this.Variazioni.splice(indx, 1);
      }
    }
    this.VariazioniChange.emit(this.Variazioni);
  }
  filtroProdtto(item: string) {
    if (item.length >= 3) {
      this.partiStore.getParti(new FiltriProdotto(item));
    }
  }
  filtroCategoria(item: string) {
    if (item.length >= 3) {
      this.partiStore.getCategorieListanofigli(new RicercaPaginazione(item, undefined, undefined));
    }
  }

}
